import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import { VISA_COUNTRIES, WHATSAPP_NUMBER } from "@/data/content";

export default function VisaServices({ onApply }) {
  return (
    <section id="visa" className="pt-24 pb-8 md:pt-32 md:pb-8 px-6 lg:px-10 bg-[#F8F9FB]" data-testid="visa-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-end mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-[#C9A227]" />
              <span className="overline">Visa Services</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0A2342] leading-[1.05]">
              500+ visas approved. <br />
              <span className="text-[#C9A227]">Zero stress.</span>
            </h2>
          </div>
          <p className="text-[#6B7280] text-lg leading-relaxed">
            From document checklists to embassy appointments and interview prep — our visa team handles the entire process. You only show up for the holiday.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {VISA_COUNTRIES.map((v, i) => (
            <motion.button
  key={v.name}
  type="button"
  onClick={() => {
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
        `Hi, I am interested in visa services for ${v.name}.`
      )}`,
      "_blank"
    );
   }}
              data-testid={`visa-${v.name.toLowerCase().replace(/\s+/g, "-")}`}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
              className="text-left bg-white rounded-2xl p-6 border border-gray-100 hover:border-[#C9A227]/40 hover:shadow-[0_18px_40px_-20px_rgba(10,35,66,0.18)] transition-all duration-500 group"
            >
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <span className="text-3xl">{v.flag}</span>
                  <div>
                    <div className="font-display text-lg text-[#0A2342]">{v.name}</div>
                    <div className="text-xs text-[#6B7280] flex items-center gap-1 mt-0.5">
                      <Clock className="w-3 h-3" /> {v.processing}
                    </div>
                  </div>
                </div>
                <span className="w-9 h-9 rounded-full bg-[#F8F9FB] group-hover:bg-[#C9A227] flex items-center justify-center transition-colors">
                  <ArrowUpRight className="w-4 h-4 text-[#0A2342] group-hover:text-white transition-colors" />
                </span>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
